import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-telegram',
  templateUrl: './telegram.component.html',
  styleUrls: ['./telegram.component.scss', '../olx/olx.component.scss']
})
export class TelegramComponent {
  menuOpen = false;
  reviews = [
    { text: 'telegram_page.testimonials_1_text', author: 'telegram_page.testimonials_1_author' },
    { text: 'telegram_page.testimonials_2_text', author: 'telegram_page.testimonials_2_author' },
    { text: 'telegram_page.testimonials_3_text', author: 'telegram_page.testimonials_3_author' }
  ];
  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }
  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    if (this.menuOpen) {
      this.toggleMenu();
    }
  }

  protected readonly environment = environment;
}
